import React, { useState } from "react";
import config from "../../script/config";
import { toast } from "react-toastify";

import { EnvelopeFill, TelephoneFill } from "react-bootstrap-icons";
import {
  FaWhatsapp,
  FaLinkedin,
  FaInstagram,
  FaYoutube,
  FaExternalLinkAlt,
  FaHtml5,
  FaCss3Alt,
  FaJsSquare,
  FaReact,
  FaGitAlt,
  FaAws
} from "react-icons/fa";


import "../../css/style.css";
import { SiGoogleplay, SiJenkins, SiUnity } from "react-icons/si";

const Footer = () => {
  const initialState = {
    name: "",
    email: "",
    mobile: "",
    subject: "",
    body: "",
  };
  const [data, setData] = useState(initialState);

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    if (loading) return;
    e.preventDefault();

    const { name, email, subject, body } = data;

    if (!name || !email || !subject || !body) {
      toast.warn("Please fill in all required fields.");
      return;
    }

    setLoading(true);

    try {
      await sendEmail();
    } finally {
      setLoading(false);
    }
  };

  /****************************************************************
   * SEND EMAIL
   * ----------
   *
   * This function handles the email notification to HR.
   */
  const sendEmail = async () => {
    const { name, email, mobile, subject, body } = data;

    try {
      const formData = new URLSearchParams();
      formData.append(
        "FormData",
        JSON.stringify({ name, email, mobile, subject, body })
      );

      const res = await fetch(config.apiEndpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: formData.toString(),
      });

      const responseData = await res.json();

      if (responseData.success) {
        toast.success("Email Sent Successfully!");
        setData(initialState);
      } else {
        toast.error(responseData.message || "Failed to send email request.");
      }
    } catch (error) {
      toast.error(`Error sending email: ${error.message}`);
      console.error(error);
    }
  };

  return (
    <footer className="text-white py-4 base_color">
      <div className="container">
        <div className="row">
          <div className="col-md-3 mb-4">
            <div className="d-flex flex-column align-items-start gap-4 text-start">
              <div>
                <h5>Let's Connect</h5>
                <hr className="hr" />
              </div>

              <div className="d-flex gap-3 flex-wrap justify-content-start">
                <a
                  href={config.Whatsapp}
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Go to WhatsApp"
                  className="d-flex align-items-center gap-2 text-decoration-none text-reset social-icon"
                >
                  <FaWhatsapp size={config.socialMediaIconSize} />
                </a>
                <a
                  href={config.Linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Go to LinkedIn"
                  className="d-flex align-items-center gap-2 text-decoration-none text-reset social-icon"
                >
                  <FaLinkedin size={config.socialMediaIconSize} />
                </a>
                <a
                  href={config.Youtube}
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Go to YouTube"
                  className="d-flex align-items-center gap-2 text-decoration-none text-reset social-icon"
                >
                  <FaYoutube size={config.socialMediaIconSize} />
                </a>
                <a
                  href={config.Instagram}
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Go to Instagram"
                  className="d-flex align-items-center gap-2 text-decoration-none text-reset social-icon"
                >
                  <FaInstagram size={config.socialMediaIconSize} />
                </a>

                <a
                  href="https://play.google.com/store/apps/dev?id=8884623684286085661"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="d-flex align-items-center gap-2 text-decoration-none text-reset social-icon"
                >
                  <SiGoogleplay size={config.socialMediaIconSize} />
                </a>
              </div>
            </div>

            <div className="mt-4 py-4">
              <h6 className="mb-3">Skills</h6>
              <hr className="hr" />
              <div className="d-flex gap-3 flex-wrap justify-content-start skill-icons">
                <FaReact title="React" />
                <FaHtml5 title="HTML5" />
                <FaCss3Alt title="CSS" />
                <FaJsSquare title="JavaScript" />
                <FaGitAlt title="Git" />
                <SiJenkins title="Jenkins" />
                <SiUnity title="Unity" />
                <FaAws title="Lambda" />
    
              </div>
            </div>
          </div>

          <div className="col-md-3 mb-4 text-start">
            <h5>Contact</h5>
            <hr className="hr" />

            <p className="medium d-flex align-items-center gap-2 text-white">
              <a
                href="https://mail.google.com/mail/?view=cm&fs=1&to=sumit.raipura@gmail.com"
                target="_blank"
                rel="noopener noreferrer"
                className="medium d-flex align-items-center gap-2 text-decoration-none text-reset mb-2 social-icon"
                title="Send Email"
              >
                <EnvelopeFill /> sumit.raipura@gmail.com
                <FaExternalLinkAlt
                  style={{ fontSize: "0.8em", marginLeft: "4px" }}
                />
              </a>
            </p>

            <p className="medium d-flex align-items-center gap-2 text-white">
              <a
                href="tel:+918093512506"
                className="d-flex align-items-center gap-2 text-decoration-none text-reset social-icon"
                title="Call Us"
              >
                <TelephoneFill /> +91 809-351-2506
                <FaExternalLinkAlt
                  style={{ fontSize: "0.8em", marginLeft: "4px" }}
                />
              </a>
            </p>

            <p className="medium d-flex align-items-center gap-2 text-white">
              <a
                href="https://wa.me/918603592692"
                target="_blank"
                rel="noopener noreferrer"
                className="d-flex align-items-center gap-2 text-decoration-none text-reset social-icon"
                title="Go to WhatsApp"
              >
                <FaWhatsapp /> Connect on WhatsApp
                <FaExternalLinkAlt
                  style={{ fontSize: "0.8em", marginLeft: "4px" }}
                />
              </a>
            </p>
          </div>

          <div className="col-md-6 mb-4 text-start">
            <h5>Send a Message</h5>
            <hr className="hr" />
            <form onSubmit={handleSubmit}>
              <div className="mb-2">
                <input
                  type="text"
                  name="name"
                  placeholder="Name"
                  className="form-control"
                  value={data.name}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="mb-2">
                <input
                  type="email"
                  name="email"
                  placeholder="Email"
                  className="form-control"
                  value={data.email}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="mb-2">
                <input
                  type="tel"
                  name="mobile"
                  placeholder="Mobile Number"
                  className="form-control"
                  value={data.mobile}
                  onChange={(e) => {
                    const value = e.target.value;

                    if (value.startsWith("+")) {
                      if (/^\+\d{0,12}$/.test(value)) {
                        setData((prev) => ({ ...prev, mobile: value }));
                      }
                    } else {
                      if (/^\d{0,10}$/.test(value)) {
                        setData((prev) => ({ ...prev, mobile: value }));
                      }
                    }
                  }}
                  inputMode="tel"
                  maxLength={13}
                />
              </div>

              <div className="mb-2">
                <input
                  type="text"
                  name="subject"
                  placeholder="Subject"
                  className="form-control"
                  value={data.subject}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="mb-2">
                <textarea
                  name="body"
                  rows="3"
                  placeholder="Message"
                  className="form-control"
                  value={data.body}
                  onChange={handleChange}
                  required
                />
              </div>
              <button
                type="submit"
                className="btn btn-primary btn-sm"
                disabled={loading}
              >
                {loading ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Sending...
                  </>
                ) : (
                  "Send Email"
                )}
              </button>
            </form>
          </div>
        </div>

        <hr className="bg-light" />
        <p className="text-center small mb-0 text-white">
          &copy; {new Date().getFullYear()} Sumit Kumar. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
